import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useCoreStore } from '../useCoreStore'

import { useActiveBrand } from './useActiveBrand'

/**
 * Returns the current active location from the store (or undefined if no active location)
 */
export const useActiveLocation = () => {
  const { activeBrand } = useActiveBrand()

  const { activeLocation } = storeToRefs(useCoreStore())

  const activeLocationId = computed(() => activeLocation.value?.id)
  const name = computed(() => activeLocation.value?.name)

  if (
    activeLocation.value &&
    activeLocation.value.brandId !== activeBrand.value.id
  ) {
    throw new Error(
      'active location does not belong to the current active brand'
    )
  }

  return {
    activeLocation,
    activeLocationId,
    name,
  }
}
